import React, { useState, useEffect } from "react";
import "./style.sass";
import assets from "../../assets";
import { useHandler } from "./handler";
import { AdminAsyncQuizRoom } from "../admin-async-quiz-room";
import { AdminLeaderboard } from "../admin-leader-board";
import { AdminQuizHistory } from "../admin-quiz-history";
import { AdminLiveQuizRoom } from "../admin-live-room";
import { useLocation } from "react-router-dom";

export const AdminQuiz = () => {
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const location = useLocation();

  const {
    getCourseDetails,
    filterData,
    selectedCourse,
    handleCourseChange,
    course,
    dynamicOptions,
    selectedValues,
    handleHierarchyChange,
    mode,
    setMode,
    createRoom,
    deadline,
    setDeadline,
    maxAttempts,
    setMaxAttempts,
    roomCode,
    setRoomCode,
    resetForm,
  } = useHandler();

  useEffect(() => {
    if (location.state?.mode) {
      setMode(location.state.mode);
    }
  }, [location.state, setMode]);

  const resetQuizFlow = () => {
    setRoomCode("");
    setShowLeaderboard(false);
    setShowHistory(false);
  };

  if (roomCode && mode === "live") {
    return <AdminLiveQuizRoom roomCode={roomCode} setRoomCode={setRoomCode} />;
  }

  if (roomCode && showHistory) {
    return <AdminQuizHistory resetQuizFlow={resetQuizFlow} />;
  }

  if (roomCode && !showLeaderboard) {
    return (
      <AdminAsyncQuizRoom
        roomCode={roomCode}
        setShowLeaderboard={setShowLeaderboard}
        setShowHistory={setShowHistory}
      />
    );
  }

  if (roomCode && showLeaderboard) {
    return (
      <AdminLeaderboard
        roomCode={roomCode}
        setShowHistory={setShowHistory}
        resetQuizFlow={resetQuizFlow}
      />
    );
  }

  return (
    <section className="quiz-room">
      <section className="quiz_container">
        <h1>
          Create a <span>{mode === "live" ? "Live" : "Async"} Quiz</span> Room
        </h1>

        <p className="subtitle">
          Set up a new interactive session for your students. <br />
          Choose a topic and get your room code instantly.
        </p>

        <section className="admin-quiz-card">
          <section className="tabs">
            <button
              className={mode === "async" ? "active" : ""}
              onClick={() => setMode("async")}
            >
              Async Quiz Mode
            </button>
            <button
              className={mode === "live" ? "active" : ""}
              onClick={() => setMode("live")}
            >
              Live Quiz Mode
            </button>
          </section>

          <section className="form-row">
            <section className="field">
              <select value={selectedCourse} onChange={handleCourseChange}>
                <option value="">Select Course</option>

                {course?.map((item, index) => (
                  <option key={index} value={item}>
                    {item.replaceAll("_", " ")}
                  </option>
                ))}
              </select>
            </section>
          </section>
          {mode !== "live" && (
            <section className="field">
              <label>Deadline</label>

              <input
                type="datetime-local"
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
              <section className="field attempts">
                <label>Maximum Attempts</label>

                <select
                  value={maxAttempts}
                  onChange={(e) => setMaxAttempts(Number(e.target.value))}
                >
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                </select>
              </section>
            </section>
          )}

          <section className="dynamic-fields">
            {filterData?.hierarchy?.map((field) => {
              const options =
                filterData?.initial?.[field] || dynamicOptions?.[field] || [];

              return (
                <section className="field" key={field}>
                  <label>
                    {field.charAt(0).toUpperCase() + field.slice(1)}
                  </label>

                  <select
                    value={selectedValues?.[field] || ""}
                    onChange={(e) =>
                      handleHierarchyChange(field, e.target.value)
                    }
                  >
                    <option value="">Select {field}</option>

                    {options?.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </section>
              );
            })}
          </section>

          <button className="create-btn" onClick={createRoom}>
            Create Room <span>→</span>
          </button>
        </section>
      </section>
    </section>
  );
};
